import * as React from 'react';
import { XCircle } from 'react-feather';

type Props = {
    close: () => void;
    setArgs: React.Dispatch<React.SetStateAction<{
        asDraft: boolean;
        forceToView: boolean;
        viewLocation?: string;
    }>>;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
}

export const Upgrade: React.FC<Props> = ({ close, setArgs, setShowModal }) => {

    return (
        <div className="view-upgrade">
            <XCircle className="feather" onClick={close}/>
            <ul>
                <li><h2>You will need to <a onClick={() => {
                    setArgs({ asDraft: true, forceToView: true, viewLocation: "/flow/needUpgrade" })
                    setShowModal(true)
                }}>upgrade</a> to add more than 10 screens.</h2></li>
                <li><h2>But, first, you must <a onClick={() => {
                    setArgs({ asDraft: true, forceToView: true, viewLocation: "/flow/needUpgrade" })
                    setShowModal(true)
                }}>Save Draft</a></h2></li>
                <li></li>
            </ul>
        </div>
    )
}